import { $http } from '@/plugins/axios';
import { AxiosResponse } from 'axios';

export const surveyService = {
    list: (): Promise<AxiosResponse> => {
        return $http.get('v1/org_admin/surveys');
    },
    listTemplate: (): Promise<AxiosResponse> => {
        return $http.get('v1/org_admin/survey_templates?type=all');
    },
    getTemplateDetail: (id: string): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/survey_templates/${id}`);
    },
    getSurveyDetail: (id: string): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/surveys/${id}`);
    },
    getSurveyResult: (id: string): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/surveys/${id}/results`);
    },
    createSurveyFromTemplate: (data: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/surveys`, data);
    },
    createDraftSurvey: (data: any): Promise<AxiosResponse> => {
        return $http.post('v1/org_admin/surveys', data);
    },
    sendSurveyToParent: (id: any, data: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/surveys/${id}/send`, data);
    },
    getAnswerOfQuestion: (id: string, questionId: string): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/surveys/${id}/questions/${questionId}`);
    },
    getParentsSurvey: (id: string): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/surveys/${id}/parent_surveys`);
    },
    getSurveyResultByParent: (id: string, parentId: string): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/surveys/${id}/parent_surveys/${parentId}`);
    },
    getParentNotificationHistory: (id: string): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/surveys/${id}/resend_history`);
    },
    listSurveyByParent: (id: string): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/surveys/${id}/students`);
    },
    deleteTemplate: (id: string): Promise<AxiosResponse> => {
        return $http.delete(`v1/org_admin/survey_templates/${id}`);
    },
    recallSurvey: (id: string): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/surveys/${id}/withdraw`);
    },
    createTemplate: (id: string, data: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/survey_templates/create_from_survey/${id}`, data);
    },
    updateSurvey: (id: string, data: any): Promise<AxiosResponse> => {
        return $http.put(`v1/org_admin/surveys/${id}`, data);
    },
    deleteSurvey: (id: string): Promise<AxiosResponse> => {
        return $http.delete(`v1/org_admin/surveys/${id}`);
    },
    duplicateTemplate: (id: string, data: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/survey_templates/${id}/duplicate`, data);
    },
    updateSurveyTemplate: (id: string, data: any): Promise<AxiosResponse> => {
        return $http.put(`v1/org_admin/survey_templates/${id}`, data);
    },
    sendSurveyWithoutId: (data: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/surveys`, data);
    },
};